/* c081 approved brand branch; original category runtime above remains intact. */
// After-only browse behavior: runtime.js never invokes this for frozen Before.
function approvedBrandRows(root) {
  var hero = root.querySelector('#temp-2026-collection-header');
  var reduce = function () { return matchMedia('(prefers-reduced-motion: reduce)').matches; };
  [].forEach.call(hero.querySelectorAll('.hero-carousel'), function (car) {
    var view = car.querySelector('.bm-viewport');
    var ul = car.querySelector('.has-list-categories');
    var prev = car.querySelector('.hero-carousel__btn--prev');
    var next = car.querySelector('.hero-carousel__btn--next');
    if (!view || !ul || !prev || !next) return;
    car.dataset.n=String(ul.children.length);car.style.setProperty('--bm-n',String(ul.children.length));
    var embla, raf = 0;
    var controls = function (over, canPrev, canNext) {
      var bounds = car.getBoundingClientRect();
      var desktop = innerWidth > 1024;
      // 44px button + 8px gap + 16px safe outer inset, measured on both sides.
      car.classList.toggle('controls-outside', desktop && bounds.x >= 68 && innerWidth - bounds.right >= 68);
      car.classList.toggle('is-overflowing', over);
      car.classList.toggle('can-scroll-prev', canPrev);
      car.classList.toggle('can-scroll-next', canNext);
      var visible = [desktop && canPrev, desktop && canNext];
      var buttons = [prev, next];
      var focused = document.activeElement;
      var lost = buttons.findIndex(function (button, index) { return focused === button && !visible[index]; });
      // Commit both states before transferring focus: a two-snap row's opposite
      // control was hidden until this update and cannot receive focus yet.
      buttons.forEach(function (button, index) {
        button.hidden = !visible[index];
        button.disabled = ![canPrev, canNext][index];
        button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
      });
      if (lost >= 0) {
        if (visible[1 - lost]) buttons[1 - lost].focus({ preventScroll: true });
        else {
          // Fitting rows and tablet resizing still need a stable focus target.
          // Prefer a fully visible destination, so the transfer stays contextual.
          var v = view.getBoundingClientRect();
          var links = [].slice.call(ul.querySelectorAll('a'));
          var target = links.find(function (a) { var b = a.getBoundingClientRect(); return b.x >= v.x - .5 && b.right <= v.right + .5; }) || links[0];
          if (target) target.focus({ preventScroll: true });
        }
      }
    };
    var sync = function () {
      // Controls never change viewport width; state comes from the actual viewport.
      var over = ul.scrollWidth > view.clientWidth + .5;
      if (embla) { var engine=embla.internalEngine(), position=engine.target.get(); controls(over, over && position < engine.limit.max-.5, over && position > engine.limit.min+.5); }
      else {
        var end = view.scrollWidth - view.clientWidth;
        controls(over, over && view.scrollLeft > .5, over && view.scrollLeft < end - .5);
      }
    };
    var remeasure = function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; if (embla) embla.reInit(options); else sync(); });
    };
    var options = {
      container: ul, align: function(){ return innerWidth <= 768 ? 16 : 0; }, containScroll: 'trimSnaps', dragFree: false,
      slidesToScroll: 'auto',
      // 18 Oct phone rows: a range hidden on phones (data-bm-desktop) is not a slide there, so the visible cards set the scroll length.
      breakpoints: { '(max-width: 768px)': { slidesToScroll: 1, slides: ':scope > li:not([data-bm-desktop])' } },
      dragThreshold: 8,
      // 18 Oct: a row whose cards all fit (e.g. 2 ranges on a phone) is not a slider, so it does not drag.
      watchDrag: function (api) { return api.canScrollNext() || api.canScrollPrev(); }
    };
    if (window.EmblaCarousel) {
      // Links click normally on desktop; touch can drag the row.
      view.addEventListener('mousedown', function (e) { if(innerWidth > 768) e.stopPropagation(); }, true);
      embla = window.EmblaCarousel(view, options);
      car.classList.add('is-embla');
      embla.on('init', sync).on('reInit', sync).on('select', sync).on('settle', sync).on('resize', sync);
      var wheelEndTimer = 0;
      var finishWheel = function () {
        wheelEndTimer = 0;
        var engine = embla.internalEngine();
        // Wheel gestures settle by one-card boundaries; arrow clicks still page.
        var slides=embla.slideNodes(),current=engine.target.get(),first=slides[0].getBoundingClientRect().left;
        var targets=slides.map(function(slide){
          return engine.limit.constrain(engine.limit.max-(slide.getBoundingClientRect().left-first));
        });
        var nearest=targets.reduce(function(best,target){
          return Math.abs(target-current)<Math.abs(best-current)?target:best;
        },targets[0]);
        engine.scrollBody.useDuration(reduce()?0:18);
        engine.scrollTo.distance(nearest-current,false);
        sync();
      };
      view.addEventListener('wheel', function (e) {
        // Only own horizontal gestures; ctrl-wheel is browser pinch zoom.
        if (e.ctrlKey || Math.abs(e.deltaX) <= Math.abs(e.deltaY) || !e.deltaX) return;
        var engine = embla.internalEngine();
        var pixels = e.deltaX * (e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? view.clientWidth : 1);
        var current = engine.target.get();
        var destination = engine.limit.constrain(current - pixels);
        if (Math.abs(destination - current) < .01 && !wheelEndTimer) return;
        e.preventDefault();
        engine.scrollBody.useDuration(0);
        engine.scrollTo.distance(destination - current, false);
        sync();
        clearTimeout(wheelEndTimer);
        // Include momentum events before returning to the nearest layout snap.
        wheelEndTimer = setTimeout(finishWheel, 160);
      }, { passive: false });
      embla.on('destroy', function () { clearTimeout(wheelEndTimer); });
    } else {
      // Blocked Embla leaves native scrolling, truthful fades and real links.
      view.addEventListener('focusin', function (e) {
        var link = e.target.closest && e.target.closest('a');
        if (link && ul.contains(link)) link.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        sync();
      });
      view.addEventListener('scroll', sync, { passive: true });
    }
    var move = function (forward) {
      if (embla) { if (forward) embla.scrollNext(reduce()); else embla.scrollPrev(reduce()); }
      else view.scrollBy({ left: (forward ? 1 : -1) * view.clientWidth * .8, behavior: reduce() ? 'auto' : 'smooth' });
    };
    // Safari pointer activation does not focus a native button automatically.
    // Establish the active control before moving, so end-state hiding can hand
    // its focus to the visible opposite arrow without scrolling the whole page.
    prev.addEventListener('click', function () { prev.focus({ preventScroll: true }); move(false); });
    next.addEventListener('click', function () { next.focus({ preventScroll: true }); move(true); });
    // c221 type cards (25 Oct): an active type card outside the visible part of the row is brought into view by moving the
    // row only (the slider, or the row's own scroll when the slider is blocked), never the page. On load it jumps, after
    // a filter change it slides (it jumps with reduced motion). A card already in view does not move the row.
    car.addEventListener('bm:row-show', function (e) {
      var li = ul.children[e.detail.index]; if (!li) return;
      var v = view.getBoundingClientRect(), b = li.getBoundingClientRect();
      if (b.left >= v.left - .5 && b.right <= v.right + .5) return;
      if (embla) {
        var i = embla.slideNodes().indexOf(li), reg = embla.internalEngine().slideRegistry || [], snap = -1;
        for (var k = 0; k < reg.length; k++) if (reg[k].indexOf(i) > -1) { snap = k; break; }
        if (snap < 0) snap = Math.min(Math.max(i, 0), embla.scrollSnapList().length - 1);
        embla.scrollTo(snap, !!e.detail.instant);
      } else view.scrollLeft += b.left - v.left - (innerWidth <= 768 ? 16 : 0);
      sync();
    });
    window.addEventListener('resize', remeasure);
    root.addEventListener('brandhero:resize-state', remeasure);
    window.addEventListener('load', remeasure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
    if (window.ResizeObserver) {
      var width = car.getBoundingClientRect().width;
      new ResizeObserver(function () {
        var nextWidth = car.getBoundingClientRect().width;
        if (Math.abs(nextWidth - width) > .5) { width = nextWidth; remeasure(); }
      }).observe(car);
    }
    sync();
  });
};

(function(){
// c221 range colour addition (24 Oct, rule 7 in snippets/bm-brand-hero.liquid): the automatic photo fade. On desktop the
// photo runs from the tag line to the card row's bottom line, so a type card can sit over it (5 or 6 cards, or a narrow
// screen). Only then the hero gets data-c221-overlap and --c221-fade-h, and bm-brand-hero.css covers the photo's bottom
// with a gradient to the hero grey from 48px above the first card that overlaps it. A row that swipes is measured
// unscrolled, so a card that can slide under the photo counts. Rechecked on resize and when the description opens or
// closes. May expand to the other heroes later.
function rangeColourFade(section,hero){
 const photo=section.querySelector('.c075-upper>.c068-panorama');if(!photo)return;
 let frame=0;
 const check=()=>{
  frame=0;
  const box=photo.getBoundingClientRect();let top=Infinity;
  const desk=innerWidth>768&&box.width&&box.height;
  // c275 (25 Oct, RC): each card that meets the photo is also marked data-c221-over, for the soft shadow of ?fade=none.
  section.querySelectorAll('.c068-navigation .has-list-categories>li').forEach(li=>{
   const r=li.getBoundingClientRect();let over=false;
   if(desk&&r.width){
    let shift=0;try{const t=getComputedStyle(li.parentElement).transform;if(t&&t!=='none')shift=new DOMMatrixReadOnly(t).m41}catch(e){}
    const left=r.left-shift,right=r.right-shift;
    over=right>box.left+.5&&left<box.right-.5&&r.bottom>box.top+.5&&r.top<box.bottom-.5;
    if(over)top=Math.min(top,r.top);
   }
   if(li.hasAttribute('data-c221-over')!==over)li.toggleAttribute('data-c221-over',over);
  });
  if(top<Infinity){photo.style.setProperty('--c221-fade-h',Math.round(box.bottom-top+48)+'px');section.setAttribute('data-c221-overlap','')}
  else{section.removeAttribute('data-c221-overlap');photo.style.removeProperty('--c221-fade-h')}
 };
 const schedule=()=>{if(!frame)frame=requestAnimationFrame(check)};
 schedule();
 window.addEventListener('resize',schedule);window.addEventListener('load',schedule);
 hero.addEventListener('brandhero:resize-state',schedule);
 if(document.fonts&&document.fonts.ready)document.fonts.ready.then(schedule);
 if(window.ResizeObserver)new ResizeObserver(schedule).observe(section);
}
// c221 colour switcher (24 Oct, rule 7): the swatch button in the brand and colour tag opens the range's other colours on
// the same line (markup: snippets/bm-range-hero.liquid, part 'switch'; styles at the end of bm-brand-hero.css). Esc and a
// click or tap outside close it; Esc returns focus to the button. On mobile, where the tag is the grey tab over the photo,
// the tab grows from its measured closed width to the full width and shrinks back to exactly that width (the closed width
// is measured again when it closes); its height never changes. The sideways list fades at an edge while colours wait
// beyond it. A tap on a colour sets a session flag, so the next page opens with the row already open (the inline script
// after the list reads it once, no animation), and the link carries an active Product Type filter (pf_t_product_type)
// only to a colour that has the type (data-bm-types). Reduced motion: no animation.
function rangeColourSwitch(section){
 const tag=section.querySelector('.c221-tag--switch'),btn=tag&&tag.querySelector('.c221-switch'),list=tag&&tag.querySelector('.c221-switch__list');
 if(!btn||!list)return;
 const mobile=matchMedia('(max-width:768px)');
 const onTab=()=>mobile.matches&&section.getAttribute('data-bm-mobile-photo')==='top'&&!section.querySelector('.c075-upper.hero-composition--text-only');
 const reduce=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
 let open=tag.hasAttribute('data-c221-open'),timer=0;
 // Changes made between still(true) and still(false) never animate: each side flushes the style first.
 const still=on=>{void tag.offsetWidth;if(on)tag.setAttribute('data-c221-instant','');else tag.removeAttribute('data-c221-instant');void tag.offsetWidth};
 const edges=()=>{const max=list.scrollWidth-list.clientWidth;list.toggleAttribute('data-c221-fade-end',open&&max>1&&list.scrollLeft<max-1);list.toggleAttribute('data-c221-fade-start',open&&list.scrollLeft>1)};
 // The end of a width animation, or no animation: the inline width goes (the stylesheet's width is the same), a closed row hides.
 const settle=()=>{clearTimeout(timer);timer=0;still(true);tag.style.width='';if(!open){tag.removeAttribute('data-c221-open');list.hidden=true}still(false);edges()};
 // The tab's closed width, measured with the row closed for a moment (no paint in between), keeping the list's scroll.
 const closedWidth=()=>{const left=list.scrollLeft;tag.style.width='';tag.removeAttribute('data-c221-open');list.hidden=true;const closed=tag.getBoundingClientRect().width;tag.setAttribute('data-c221-open','');list.hidden=false;list.scrollLeft=left;return closed};
 const types=a=>{try{return JSON.parse(a.getAttribute('data-bm-types')||'[]')}catch(e){return[]}};
 const sync=()=>{
  const want=new URLSearchParams(location.search).getAll('pf_t_product_type').filter(v=>v.indexOf('Sub Category_')===0);
  list.querySelectorAll('a.bm-colour-switch').forEach(a=>{
   const base=a.dataset.bmBase||(a.dataset.bmBase=a.getAttribute('href')),has=types(a),keep=want.filter(v=>has.indexOf(v.slice(13))>-1);
   a.setAttribute('href',keep.length?base+'?'+keep.map(v=>'pf_t_product_type='+encodeURIComponent(v).replace(/%20/g,'+')).join('&'):base);
  });
 };
 const setOpen=on=>{
  if(on===open)return;open=on;btn.setAttribute('aria-expanded',String(on));
  const animate=onTab()&&!reduce();
  clearTimeout(timer);timer=0;
  if(on){
   sync();
   if(animate){
    // From the closed width (measured now) to the open width (the stylesheet's, measured with the row open), animated.
    const from=tag.getBoundingClientRect().width;
    still(true);tag.style.width='';tag.setAttribute('data-c221-open','');list.hidden=false;list.scrollLeft=0;
    const to=tag.getBoundingClientRect().width;tag.style.width=from+'px';still(false);
    tag.style.width=to+'px';timer=setTimeout(settle,600);
   }else{tag.setAttribute('data-c221-open','');list.hidden=false;list.scrollLeft=0}
   requestAnimationFrame(()=>{if(open){tag.setAttribute('data-c221-shown','');edges()}});
  }else{
   if(animate){
    // From the width now (open, or part way) back to exactly the closed width; the row hides when it gets there.
    const from=tag.getBoundingClientRect().width;
    still(true);const to=closedWidth();tag.style.width=from+'px';still(false);
    tag.removeAttribute('data-c221-shown');tag.style.width=to+'px';timer=setTimeout(settle,600);
   }else{tag.removeAttribute('data-c221-shown');settle()}
  }
 };
 tag.addEventListener('transitionend',e=>{if(e.target===tag&&e.propertyName==='width'&&timer)settle()});
 btn.addEventListener('click',()=>setOpen(!open));
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&open){setOpen(false);btn.focus()}});
 // Outside: a click, or a tap (pointer down and up within 10px; a scroll gesture cancels the pointer and keeps it open).
 document.addEventListener('click',e=>{if(open&&!tag.contains(e.target))setOpen(false)});
 let down=null;
 document.addEventListener('pointerdown',e=>{down=open&&!tag.contains(e.target)?[e.clientX,e.clientY]:null},{passive:true});
 document.addEventListener('pointerup',e=>{if(down&&open&&Math.abs(e.clientX-down[0])<10&&Math.abs(e.clientY-down[1])<10)setOpen(false);down=null},{passive:true});
 document.addEventListener('pointercancel',()=>{down=null},{passive:true});
 list.addEventListener('scroll',edges,{passive:true});
 list.addEventListener('pointerdown',sync,{passive:true});list.addEventListener('focusin',sync);
 list.addEventListener('click',e=>{
  const a=e.target.closest('a.bm-colour-switch');if(!a)return;sync();
  if(e.button===0&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&!e.altKey){try{sessionStorage.setItem('bm-c221-open',JSON.stringify({p:new URL(a.getAttribute('href'),location.href).pathname,t:Date.now()}))}catch(err){}}
 });
 window.addEventListener('resize',()=>{if(open&&!timer)requestAnimationFrame(edges)});
 const breakpoint=()=>{if(timer)settle();else if(open){still(true);tag.style.width='';still(false);edges()}};
 if(mobile.addEventListener)mobile.addEventListener('change',breakpoint);else if(mobile.addListener)mobile.addListener(breakpoint);
 // Opened on arrival (the inline script after the list, from the session flag): sync the links, then allow animation again.
 if(open){sync();requestAnimationFrame(()=>{edges();requestAnimationFrame(()=>tag.removeAttribute('data-c221-instant'))})}
}
// c221 type card active state (25 Oct, rules 7 and 8). window.bmTypeCards (the inline script after the row in
// snippets/bm-brand-hero.liquid) marks the type cards from the address before the first paint; the cards never move.
// Boost changes the filters without a reload: the sidebar, the mobile drawer and the chips call history.pushState, back
// and forward fire popstate. So it runs again after every address change, and the first active card is brought into the
// visible part of the row when it is outside it (bm:row-show, mobile and tablet rows that swipe).
function typeCardsLive(section){
 const row=section.querySelector('[data-bm-range-types]');if(!row||!window.bmTypeCards)return;
 const car=row.querySelector('.hero-carousel');
 let last=null,load=true;
 const run=()=>{if(location.search===last)return;last=location.search;let i=-1;try{i=window.bmTypeCards(row)}catch(e){}
  if(i>-1&&car)car.dispatchEvent(new CustomEvent('bm:row-show',{detail:{index:i,instant:load||matchMedia('(prefers-reduced-motion: reduce)').matches}}));load=false};
 ['pushState','replaceState'].forEach(m=>{const orig=history[m];if(typeof orig!=='function')return;history[m]=function(){const r=orig.apply(this,arguments);setTimeout(run,0);return r}});
 window.addEventListener('popstate',()=>setTimeout(run,0));
 run();
}
function startApprovedBrand(){
 const section=document.querySelector('#temp-2026-collection-header.bm-approved-brand');if(!section)return;
 const hero=section.parentElement;
 if(window.bmPrepareBrandHeroLogo)window.bmPrepareBrandHeroLogo(section);
 approvedBrandRows(hero);
 // c258: rule 8 (level 2 pages) shares rule 7's photo fade; it has no colour switcher (rangeColourSwitch returns).
 if(section.dataset.bmRule==='7'||section.dataset.bmRule==='8'){rangeColourFade(section,hero);rangeColourSwitch(section);typeCardsLive(section)}
 section.querySelectorAll('.hero-row').forEach(row=>{const image=row.querySelector(row.classList.contains('bm-row--v')?'.item-collection-img':'.hero-carousel');if(!image)return;const sync=()=>row.style.setProperty('--hero-label-image-height',image.getBoundingClientRect().height+'px');if(window.ResizeObserver)new ResizeObserver(sync).observe(image);sync()});
 section.querySelectorAll('details').forEach(d=>{const summary=d.querySelector('summary');d.addEventListener('toggle',()=>summary.setAttribute('aria-expanded',String(d.open)))});
 const compactReviews=()=>section.querySelectorAll('.c068-trust .custom-count').forEach(count=>{if(count.querySelector('.trust-count-full'))return;const value=count.textContent.trim(),match=value.match(/^\(([\d,]+)\s+reviews?\)$/i);if(!match)return;const full=document.createElement('span'),compact=document.createElement('span');full.className='trust-count-full';full.textContent=value;compact.className='trust-count-compact';compact.textContent='('+match[1]+')';compact.setAttribute('aria-hidden','true');count.replaceChildren(full,compact);count.title=value});
 compactReviews();const trust=section.querySelector('.c068-trust');if(trust&&!trust.querySelector('[data-bm-review-summary]')&&window.MutationObserver)new MutationObserver(compactReviews).observe(trust,{childList:true,subtree:true,characterData:true});
  const description=hero.querySelector('.c068-description');
  if(description){
   const teaser=description.querySelector('.c068-teaser'),about=description.querySelector('.c068-about'),summary=about.querySelector('summary');
   const full=description.querySelector('.c068-full'),boundaries=[];
   // Keep the original anchors and emphasis in the measured excerpt. The
   // full merchant description remains untouched inside native details.
   const walker=document.createTreeWalker(full,NodeFilter.SHOW_TEXT);
   let node;while((node=walker.nextNode())){for(const match of node.textContent.matchAll(/\S+/g))boundaries.push({node,end:match.index+match[0].length,word:match[0]})}
   const source=boundaries.map(part=>part.word).join(' '),words=source.split(' ');
   function richPrefix(target,count){
    const end=boundaries[Math.max(0,Math.min(count,boundaries.length)-1)];
    if(!end){target.textContent='';return}
    const range=document.createRange();range.selectNodeContents(full);range.setEnd(end.node,end.end);
    const fragment=range.cloneContents();
    // Excerpts are inline; keep native links while removing block wrappers.
    fragment.querySelectorAll('p,div,ul,ol,li,h1,h2,h3,h4,h5,h6,blockquote').forEach(block=>block.replaceWith(...block.childNodes,document.createTextNode(' ')));
    fragment.querySelectorAll('[id]').forEach(element=>element.removeAttribute('id'));
    target.replaceChildren(fragment,document.createTextNode(' '));
   }
   let frame=0,descriptionMotion=null,descriptionClosing=false,closedDescriptionHeight=0;
   // The prefix the live teaser holds, so an unchanged cut is not rewritten.
   let teaserCount=-1,teaserText=null;
   function syncDescriptionIntent(expanded){
    summary.setAttribute('aria-expanded',String(expanded));
    summary.setAttribute('aria-label',summary.querySelector(expanded?'.c075-less':'.c075-more').textContent.trim());
   }
   function finishDescription(expanded){
    descriptionMotion=null;descriptionClosing=false;
    description.classList.remove('description-animating','description-closing');
    if(!expanded&&full.contains(document.activeElement))summary.focus({preventScroll:true});
    about.open=expanded;syncDescriptionIntent(expanded);
    if(!expanded)scheduleDescription();
    hero.dispatchEvent(new Event('brandhero:resize-state'));
   }
   function stopDescriptionMotion(finishClosing=false){
    const closing=descriptionClosing;
    if(descriptionMotion){descriptionMotion.cancel();descriptionMotion=null}
    descriptionClosing=false;description.classList.remove('description-animating','description-closing');
    if(finishClosing&&closing)finishDescription(false);
   }
   function moveDescription(from,expanded){
    const to=expanded?description.getBoundingClientRect().height:closedDescriptionHeight;
    syncDescriptionIntent(expanded);
    if(!from||!to||!description.animate||matchMedia('(prefers-reduced-motion: reduce)').matches||Math.abs(to-from)<1){finishDescription(expanded);return}
    descriptionClosing=!expanded;
    description.classList.toggle('description-closing',descriptionClosing);
    description.classList.add('description-animating');
    const animation=description.animate([{height:from+'px'},{height:to+'px'}],{duration:220,easing:'cubic-bezier(.2,0,0,1)'});
    descriptionMotion=animation;
    animation.onfinish=()=>{if(descriptionMotion===animation)finishDescription(expanded)};
   }
   // Safari fires no loadingdone for stylesheet fonts. While fonts are loading, a
   // fit also waits on ready, and refits only when that cycle fired no font event.
   // It adds a refit where none would run; it never replaces the loadingdone one.
   let fontEvents=0,fontWatch=null,descriptionFit=null;
   // The merchant markup is fixed for this controller's lifetime. Reuse the
   // fitted prefix while its width, typography, labels and font cycle are stable.
   function descriptionFitSignature(width,style,controlStyle){
    return [width,style.getPropertyValue('--hero-description-lines'),style.font,
     style.lineHeight,style.letterSpacing,style.wordSpacing,style.textTransform,
     style.textIndent,style.fontFeatureSettings,style.fontVariationSettings,
     controlStyle.font,controlStyle.letterSpacing,controlStyle.wordSpacing,
     summary.textContent,fontEvents].join('\u001f');
   }
   function canReuseDescriptionFit(previous,key,focused,open,wasComplete){
    if(!previous||previous.key!==key)return false;
    // Short text keeps its disclosure while focused or deliberately expanded.
    // Its first eligible blur/close must still remove that disclosure.
    const shouldComplete=previous.complete&&!focused&&(!open||wasComplete);
    return shouldComplete===wasComplete&&(!wasComplete||open);
   }
   function watchFonts(){
    if(!document.fonts||document.fonts.status!=='loading')return;
    const ready=document.fonts.ready;if(ready===fontWatch)return;
    fontWatch=ready;const seen=fontEvents;
    ready.then(()=>{if(fontEvents===seen){fontEvents++;scheduleDescription()}});
   }
   // Native details switches the inline More and bottom Show less labels in
   // place. Do not animate or carry the focused summary between endpoints.
   function fitDescription(){
    stopDescriptionMotion(true);
    const measuredWidth=description.getBoundingClientRect().width;
    const descriptionStyle=getComputedStyle(description),controlStyle=getComputedStyle(summary);
    const fitKey=descriptionFitSignature(measuredWidth,descriptionStyle,controlStyle);
    const wasComplete=description.classList.contains('description-complete'),focused=document.activeElement===summary;
    if(canReuseDescriptionFit(descriptionFit,fitKey,focused,about.open,wasComplete)){watchFonts();return}
    const width=measuredWidth+'px';
    function makeProbe(){
     const probe=description.cloneNode(true);probe.classList.add('description-ready','description-measure');probe.classList.remove('description-complete');
     probe.setAttribute('aria-hidden','true');probe.inert=true;
     Object.assign(probe.style,{position:'absolute',visibility:'hidden',pointerEvents:'none',width,maxWidth:'none',inset:'0 auto auto 0'});
     return probe;
    }
    // Both hidden probes are built before insertion and share one layout: the open
    // copy measures the full text, the inline copy predicts the cut. Page scripts
    // that watch the DOM then see one insertion, not a mutation for every step.
    const probe=makeProbe(),line=makeProbe();
    const d=probe.querySelector('.c068-about'),f=probe.querySelector('.c068-full');
    d.open=true;d.querySelector('summary').style.display='none';
    let p=line.querySelector('.c068-teaser');const lineAbout=line.querySelector('.c068-about'),s=lineAbout.querySelector('summary');
    s.style.display='none';s.style.removeProperty('display');lineAbout.open=false;
    // Measure the closed inline control outside native details. Safari can omit
    // closed-details descendants from their display:contents parent's geometry.
    const inlineControl=document.createElement('span');inlineControl.className=lineAbout.className;inlineControl.append(s);lineAbout.replaceWith(inlineControl);
    const total=words.length,heights=new Map();let shown=-1;
    if(boundaries.length){richPrefix(p,total);shown=total}
    // The open copy stays last, where a single probe has always been measured.
    description.after(line,probe);
    const expandedTextHeight=f.getBoundingClientRect().height;
    const lineCount=parseInt(descriptionStyle.getPropertyValue('--hero-description-lines'),10)||3;
    const limit=parseFloat(descriptionStyle.lineHeight)*lineCount,complete=expandedTextHeight<=limit+.5;
    if(complete&&!focused&&(!about.open||wasComplete)){
     line.remove();
     description.classList.add('description-ready','description-complete');about.open=true;teaser.textContent=source;teaserCount=-1;probe.remove();descriptionFit={key:fitKey,complete};watchFonts();return;
    }
    // A detached copy takes each prefix, then replaces the teaser in one step.
    function show(n){if(n===shown)return;const next=p.cloneNode(false);richPrefix(next,n);p.replaceWith(next);p=next;shown=n}
    function prefixHeight(){
     const range=document.createRange();range.selectNodeContents(p);
     const rects=[...range.getClientRects()].filter(r=>r.width>0&&r.height>0),control=s.getBoundingClientRect();
     if(!rects.length)return control.height;
     return Math.max(control.bottom,...rects.map(r=>r.bottom))-Math.min(control.top,...rects.map(r=>r.top));
    }
    function sharesFinalLine(){
     const range=document.createRange();range.selectNodeContents(p);
     const last=[...range.getClientRects()].filter(r=>r.width>0).at(-1),control=s.getBoundingClientRect(),bounds=line.getBoundingClientRect();
     // Safari text fragments and inline controls can have different font-box centres.
     // They share a line when their vertical boxes overlap, not when centres match.
     const overlap=last?Math.min(last.bottom,control.bottom)-Math.max(last.top,control.top):0;
     return !!last&&prefixHeight()<=limit+.5&&overlap>=Math.min(last.height,control.height)*.5&&control.x>=last.right-1;
    }
    function fits(n){if(!heights.has(n)){show(n);heights.set(n,prefixHeight()<=limit+.5)}return heights.get(n)}
    // The whole text, already laid out, predicts the cut from each word's line. It
    // only decides where to look first: every decision below reads a real prefix.
    function predictCut(){
     if(shown!==total)return 1;
     const fallback=teaserCount>0?teaserCount:Math.ceil(total/2),lineHeight=parseFloat(descriptionStyle.lineHeight);
     const range=document.createRange(),texts=document.createTreeWalker(p,NodeFilter.SHOW_TEXT),tokens=[];let text;
     // Words are read only until one line past the limit.
     scan:while((text=texts.nextNode()))for(const match of text.textContent.matchAll(/\S+/g)){
      if(match[0]!==words[tokens.length])return fallback;
      range.setStart(text,match.index);range.setEnd(text,match.index+match[0].length);
      const rects=range.getClientRects();if(!rects.length)return fallback;
      tokens.push({node:text,first:rects[0],last:rects[rects.length-1]});
      if(rects[0].top-tokens[0].first.top>limit+lineHeight)break scan;
     }
     if(!tokens.length)return fallback;
     const control=s.getBoundingClientRect(),box=line.getBoundingClientRect(),boxStyle=getComputedStyle(line);
     const right=box.right-parseFloat(boxStyle.paddingRight)-parseFloat(boxStyle.borderRightWidth);
     let gap=parseFloat(descriptionStyle.fontSize)*.28;
     for(let i=1;i<tokens.length;i++){const a=tokens[i-1],b=tokens[i];if(a.node===b.node&&Math.abs(a.last.top-b.first.top)<1&&b.first.left>a.last.right){gap=b.first.left-a.last.right;break}}
     const top=tokens[0].first.top;let bottom=-Infinity;
     for(let n=1;n<=tokens.length;n++){
      const token=tokens[n-1];bottom=Math.max(bottom,token.last.bottom);
      const wraps=token.last.right+gap+control.width>right+.5;
      if(bottom-top+(wraps?lineHeight:0)>limit+.5)return n-1;
     }
     return tokens.length;
    }
    const guess=Math.min(total,Math.max(1,predictCut()));
    probe.remove();
    description.classList.remove('description-complete');description.classList.add('description-ready');
    if(wasComplete)about.open=false;
    // Combined line height grows monotonically; same-line placement does not
    // when a control briefly wraps alone. Find the height bound first, then
    // step back only far enough to keep the control with the last text words.
    // Bracketing the bound from the prediction, then bisecting, finds the same
    // largest fitting word count as a binary search over every count.
    let low=0,high=total+1,step=1;
    const test=n=>{if(fits(n))low=n;else high=n};
    if(guess<total)test(guess+1);
    if(low<guess)test(guess);
    while(high-low>1){test(low&&high<=total?Math.floor((low+high)/2):low?Math.min(total,low+step):Math.max(1,high-step));step*=2}
    let best=low;const heightBound=best;show(best);while(best>0&&!sharesFinalLine()){best--;show(best)}
    if(!best){best=heightBound;show(best)}
    // The hidden probe is absolutely positioned at a fixed width, so its height does
    // not depend on the live teaser. Reading it first avoids one more forced layout.
    closedDescriptionHeight=line.getBoundingClientRect().height;
    // Rich markup can exceed the line limit even when its flattened text fits.
    // In that case the native more control reveals the original formatting.
    const count=Math.max(1,best);
    if(count!==teaserCount||teaser.textContent!==teaserText){richPrefix(teaser,count);teaserCount=count;teaserText=teaser.textContent}
    line.remove();descriptionFit={key:fitKey,complete};watchFonts();
   }
   function scheduleDescription(){if(!frame)frame=requestAnimationFrame(()=>{frame=0;fitDescription()})}
   fitDescription();
   let observedWidth=description.getBoundingClientRect().width;
   new ResizeObserver(entries=>{const width=entries[0].contentRect.width;if(Math.abs(width-observedWidth)>.5){observedWidth=width;scheduleDescription()}}).observe(description);
   if(document.fonts){document.fonts.addEventListener('loadingdone',()=>{fontEvents++;scheduleDescription()});document.fonts.addEventListener('loadingerror',()=>{fontEvents++;scheduleDescription()})}
   summary.addEventListener('blur',scheduleDescription);
   summary.addEventListener('click',event=>{
    // Keep native details content visible through closing. A reversal starts
    // from its painted height; only the final close commits the native state.
    const from=description.getBoundingClientRect().height,expanded=!about.open||descriptionClosing;
    if(frame){cancelAnimationFrame(frame);frame=0}
    stopDescriptionMotion();event.preventDefault();
    about.open=true;moveDescription(from,expanded);
   });
   about.addEventListener('toggle',()=>{
    syncDescriptionIntent(about.open&&!descriptionClosing);
    if(!about.open){stopDescriptionMotion();scheduleDescription();}
    hero.dispatchEvent(new Event('brandhero:resize-state'));
   });
  }

}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',startApprovedBrand);else startApprovedBrand();
})();
